import Plyr from 'plyr'

const player = new Plyr('#video');
